import { useQuery } from '@apollo/client';
import invariant from 'tiny-invariant';
import { ApolloProviderV4 } from '~/apollo/client-v4';
import { graphql } from '~/apollo/generated/v4';
import { SpinnerPlaceholder } from '~/components/common/SpinnerPlaceholder';
import { CollapsibleCard } from '~/components/ui/collapse';
import { SupplementalDocumentList } from '~/components/upload/supporting-object/supplemental-documents/supplemental-document-list';
import { SupplementalDocumentUploader } from '~/components/upload/supporting-object/supplemental-documents/supplemental-document-uploader';
import { useRouteParam } from '~/hooks/routing';
import { createRefetchQueries } from '~/utils/graphql';

const UPLOAD_OUTCROP_SUPPLEMENTAL_DOCS_ROUTE = graphql(`
  query UploadOutcropSupplementalDocsRoute($id: ID!) {
    outcropGet(id: $id) {
      id
      supplementalDocuments {
        ...supplementalDocumentParts
        file {
          ...fileParts
        }
      }
    }
  }
`);

export default function UploadOutcropSupplementalDocumentsPage() {
  return (
    <ApolloProviderV4>
      <UploadOutcropSupplementalDocumentsPageInner />
    </ApolloProviderV4>
  );
}

function UploadOutcropSupplementalDocumentsPageInner() {
  const outcropId = useRouteParam('outcropId', parseInt);

  const { data, loading } = useQuery(UPLOAD_OUTCROP_SUPPLEMENTAL_DOCS_ROUTE, {
    variables: { id: outcropId },
  });

  const refetchQueries = createRefetchQueries([
    {
      query: UPLOAD_OUTCROP_SUPPLEMENTAL_DOCS_ROUTE,
      variables: { id: outcropId },
    },
  ]);

  const docs = data?.outcropGet?.supplementalDocuments;

  if (loading) return <SpinnerPlaceholder />;
  invariant(docs, 'Error loading supplemental documents');

  return (
    <div className="space-y-4">
      <CollapsibleCard title="Upload Supplemental Documents">
        <SupplementalDocumentUploader
          outcropId={outcropId}
          refetchQueries={refetchQueries}
        />
      </CollapsibleCard>

      <SupplementalDocumentList
        supplementalDocuments={docs}
        refetchQueries={refetchQueries}
      />
    </div>
  );
}
